import { useEffect, useRef, useState } from "react";
import {
    SmartAlert,
    SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { get, post } from "../../services/smartApiService";

import AgencyForm from "./AgencyForm";
import { showAlertAutoClose } from "../../services/notifyService";
import { AGENCY_URLS } from "../../api/AdminUrls";
import AgencyDetails from "./AgencyDetails";
import { USER_LOGO } from "../../services/ImageService";
import SdsImageLoader from "../../services/site/SdsImageLoader";
const Agency = () => {
  const [tabData, setTabData] = useState<any[]>([]);
  const { openModal, closeModal, setTitle } = useSiteContext();

  const loadTableData = () => {
    let URL = AGENCY_URLS.GET_ALL;
    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  useEffect(() => {
     setTitle("Agency")
   }, []);
  useEffect(() => {
   loadTableData();
  }, []);
 
  const openOfficesForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Agency Update" : "Agency Form"}</>,
      content: <AgencyForm loadTableData={loadTableData} dataIn={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
 

  const viewEditForm = (id: any) => {
    const subscription = post(AGENCY_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openOfficesForm(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
  const deleteData = (id: any) => {
    const subscription = post(AGENCY_URLS.DELETE, { id: id }).subscribe(
      (response) => {
        showAlertAutoClose("Deleted Successfully...", "success");
        closeModal();
        loadTableData();
        // setLoading(false);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Agency Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this Agency? This action cannot be reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };
  const buttons = [
    // {
    //     label: "",
    //     type: "icon",
    //     leftIcon: "fa fa-eye",
    //     classList: ["smart-hims-table-view-icon"],
    //     onClick: (data: any) => {
    //       // openViewDetails(data);
    //     },
    //   },
      {
        label: "",
        type: "icon",
        leftIcon: " fa-pencil-square",
        classList: ["smart-hims-table-edit-icon"],
        onClick: (data: any) => {
          viewEditForm(data["ID"]);
        },
      },
      {
        label: "",
        type: "icon",
        leftIcon: "fa fa-trash",
        classList: ["smart-hims-table-delete-icon"],
        onClick: (data: any) => {
          openDeleteModal(data["ID"]);
        },
      },
  ];

  

  const GetLogo=(_data:any)=>{
    return(
      <>
     <div className="">
     <SdsImageLoader
        name="logo"
        id={_data.ID}
        url={AGENCY_URLS.GET_IMAGE}
        containerStyle={{ width: "50px", height: "50px", margin: "auto" }}
        imageStyle={{ borderRadius: "50%" }}
      />
     </div>
      </>
    )
  }

 
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },

    {
      title: "Agency Name",
      index: "agency_name",
    },
    {
      title: "Name",
      index: "ename",
    },
    {
      title: "Agency Logo",
      index: "ename",
      valueFunction:GetLogo
    },

    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
  
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
    
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        {
          type: "REFRESH",
          action: loadTableData,
        },
        // {
        //   type: "EXPORT", className:"smart-third-button"
        // },
        {
          label: "Add",
          icon: "fa-plus",
          type: "CUSTOM",
          className: "smart-third-button",
          action: openOfficesForm,
        },
      ],
    },
  ];
 
  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={tabData}
          tableTop={tableTop}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          // paginationProps={{
          //   pageSize: 10,
          // }}
        />
      </div>
    </>
  );
};

export default Agency